<script setup lang="ts">
import CreditIcon from '@/components/common/CreditIcon/index.vue'

interface Props {
  credits: number | string
  points: number | string
  /** compact: dùng cho mobile, chỉ hiển thị icon, ẩn số */
  compact?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  compact: false,
})

const formatNumber = (value: number | string) => {
  const n = Number(value ?? 0)
  if (Number.isNaN(n))
    return '0'

  return n.toLocaleString('en-US')
}
</script>

<template>
  <div
    class="inline-flex items-center justify-between rounded-full !bg-[#F7F6F7] dark:!bg-[#121212] shadow-sm px-3 sm:px-4 py-1.5 gap-3 sm:gap-4 min-h-[32px] sm:min-h-[36px]"
  >
    <!-- Left: credits (icon cũ) -->
    <div class="flex items-center gap-1.5">
      <CreditIcon type="basic" :size="16" />

      <span
        v-if="!compact"
        class="font-semibold text-xs sm:text-sm leading-none"
      >
        {{ formatNumber(props.credits) }}
      </span>
    </div>

    <!-- divider (tablet/desktop only) -->
    <div class="w-px h-4 bg-gray-200 hidden sm:block" />

    <!-- Right: points (icon cũ màu tím) -->
    <div class="flex items-center gap-1.5">
      <CreditIcon type="advanced" :size="16" />

      <span
        v-if="!compact"
        class="font-semibold text-purple-600 text-xs sm:text-sm leading-none"
      >
        {{ formatNumber(props.points) }}
      </span>
    </div>
  </div>
</template>
